import { BUYER_PROFILE_LINKS } from '../constants/links';

export const parseBuyerProfileTabs = user => {
  if (!user?.buyer?.credit_card_last_numbers) return BUYER_PROFILE_LINKS.filter((_, i) => i !== 2);
  return BUYER_PROFILE_LINKS;
};
